import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const whoisFreaks = defineConnector({
  identifier: "whoisFreaks",
  name: "WhoisFreaks",
  tagLine: "WHOIS, DNS, and domain availability data",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://api\\.whoisfreaks\\.com/.*",
  auth: (app) => queryAuth([{ name: "apiKey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [WhoisFreaks](https://whoisfreaks.com/documentation/api-docs) and copy the API key from your dashboard.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "WhoisFreaks API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.whoisfreaks.com/v1.0/whois?whois=live&domainName=example.com",
  },
});
